export default __webpack_public_path__ + "static/media/ante-trust-a.77fa9f48.svg";